/**
 * Constants used throughout the AI Assistant application
 */

/**
 * Empty GUID constant used for delayed session initialization
 * When a session ID equals this value, it indicates the session hasn't been created yet
 */
export const EMPTY_GUID = '00000000-0000-0000-0000-000000000000';

